import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import { getFromSize } from './copy.js';
export const ListItem = styled.li.withConfig({ displayName: "brc-sc-ListItem", componentId: "brc-sc-wz1lao" }) `
  color: ${({ light, theme }) => (light ? theme.navNeutral400 : theme.navNeutralDark)};
  font-family: ${({ theme }) => theme.fontPrimary}
  font-size: ${getFromSize('fontSize')};
  font-weight: ${({ bold }) => (bold ? 800 : 400)};
  line-height: ${getFromSize('lineHeight')};
`;
ListItem.displayName = 'ListItem';
export const UnorderedList = (props) => _jsx("ul", Object.assign({}, props));
export const OrderedList = (props) => _jsx("ol", Object.assign({}, props));
//# sourceMappingURL=list.js.map